import React, { useState, useEffect } from "react";
import { Grid, Box, Modal, Typography, Paper, IconButton } from "@mui/material";
import { devError, devLog } from "../../functions/logging";

const MDRReportsView = () => {
  useEffect(() => {
    const fetchAll = async () => {
      try {
      } catch (error) {
        devError(error);
      }
    };
    fetchAll();
  }, []);

  return (
    <Box
      sx={{
        height: "calc(100vh - 60px)",
        //        p: 2,
        backgroundColor: "background.default",
      }}
    >
      <Grid
        container
        sx={{
          height: "100%",
          paddingTop: "0px",
          paddingLeft: "20px",
          paddingRight: "20px",
          paddingTop: "20px",
          overflow: "hidden",
          flexDirection: "row",
        }}
        spacing={2}
      >
        <Typography>MDR</Typography>
      </Grid>
    </Box>
  );
};

export default MDRReportsView;
